'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _lodash = require('lodash');
var _lodash2 = _interopRequireDefault(_lodash);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactTooltip = require('react-tooltip');
var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Renders a component that provides a hover over tooltip.
 */
var TooltipBase = function (_React$Component) {
  _inherits(TooltipBase, _React$Component);
  function TooltipBase() {
    _classCallCheck(this, TooltipBase);
    return _possibleConstructorReturn(this, (TooltipBase.__proto__ || Object.getPrototypeOf(TooltipBase)).apply(this, arguments));
  }
  _createClass(TooltipBase, [{
    key: 'render',
    value: function () {
      function render() {
        var id = this.props.id || _lodash2['default'].uniqueId('tooltip_');
        return _react2['default'].createElement(_reactTooltip2['default'], _extends({
          id: id,
          'class': this.props.className,
          place: this.props.placement,
          effect: 'solid'
        }, this.props), this.props.children);
      }
      return render;
    }()
  }]);
  return TooltipBase;
}(_react2['default'].Component);
TooltipBase.propTypes = {
  /**
   * The id assigned to the tooltip should match the value assigned to the data-for attribute added to the element
   * for which we are showing the tooltip.
   */
  id: _propTypes2['default'].string,
  /**
   * The position where the tooltip will be shown.
   */
  placement: _propTypes2['default'].oneOf(['top', 'bottom', 'right', 'left'])
};
TooltipBase.displayName = 'Tooltip';
exports['default'] = TooltipBase;